export const toCategories = categories => {
  const sections = {}
  const list = []
  Object.keys(categories).forEach(categoryName => {
    sections[categoryName] = categories[categoryName].blocks.map(block =>
      toBlock(block, categories[categoryName].id, categories[categoryName].name)
    )
    list.push({
      value: categories[categoryName].id,
      label: categories[categoryName].name
    })
  })

  return [sections, list]
}

export const toBlock = (block, sectionId, sectionName) => {
  const {
    id,
    name,
    visible,
    system,
    type,
    content,
    createdBy,
    createdAt,
    updatedBy,
    updatedAt,
    subType
  } = block
  return {
    id,
    name,
    category: { value: sectionId, label: sectionName },
    visible: visible ? 'everyone' : 'me',
    system,
    type,
    subType,
    content,
    createdBy: createdBy ? `${createdBy.firstName} ${createdBy.lastName}` : '',
    createdAt,
    updatedBy: updatedBy ? `${updatedBy.firstName} ${updatedBy.lastName}` : '',
    updatedAt
  }
}

export const fromTemplate = (content, details) => {
  return {
    content,
    pageType: details.pageType.toUpperCase(),
    title: details.name
  }
}

export const fromBlock = (block, content) => ({
  content,
  name: block.name,
  sectionId: block.category.value,
  type: block.type.toUpperCase(),
  visible: block.visible === 'me' ? false : true
})
